import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import React from "react";
import classNames from "classnames";
import AwesomeIcon from "../../AwesomeIcon";
import { faCamera, faFolderClosed } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
function MobileUpload(_ref) {
  var onAddFile = _ref.onAddFile,
    setIsGuidelineModal = _ref.setIsGuidelineModal,
    title = _ref.title,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("space-y-5 text-left mt-4 sm:hidden", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-md uppercase"
  }, t(title)), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 gap-5"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onAddFile,
    className: "border border-gray-600 dark:bg-gray-800 p-5 rounded-lg flex justify-center space-x-4 items-center",
    type: "button"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faFolderClosed
  }), /*#__PURE__*/React.createElement("p", null, t("button.files"))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setIsGuidelineModal && setIsGuidelineModal(true);
    },
    className: "border border-gray-600 dark:bg-gray-800 p-5 rounded-lg flex justify-center space-x-4 items-center",
    type: "button"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCamera
  }), /*#__PURE__*/React.createElement("p", null, t("button.camera")))));
}
export default MobileUpload;